module.exports = __webpack_public_path__ + "static/media/pocket-kit-01.fc74380c.png";